import LargeHeadingCard from './LargeHeadingCard';
export default LargeHeadingCard;
